export default class Board {
  /**
   * Represents a board
   */
  constructor() {
    this._b = [
      ['-', '-', '-'],
      ['-', '-', '-'],
      ['-', '-', '-']
    ];
    this._result = 'ongoing';
    this._movesCount = 0;
  }

  /**
   * Tries to make move based on given parameters
   * @param {number} x 
   * @param {number} y 
   * @param {character} who 
   * @returns false if move was not possible
   * @returns true if move was possible
   */
  makeMove(x, y, who) {
    if (who != 'X' && who != 'O') {
      console.log("ERROR:invalid move input")
      return false;
    }
    if (typeof (x) != 'number' || typeof (y) != 'number') {
      console.log("ERROR:invalid move input")
      return false;
    }
    if (this._result != 'ongoing') {
      console.log("ERROR:cant move when game is decided")
      return false;
    }
    if (x < 0 || x > 2 || y < 0 || y > 2) {
      console.log("ERROR:out of bound move")
      return false;
    }
    if (this._b[x][y] != '-') {
      console.log("ERROR:cant move at non empty square")
      return false;
    }
    this._b[x][y] = who;
    this._movesCount++;
    if (this._checkIfWon(who)) {
      this._result = who;
    } else {
      if (this._movesCount == 9) {
        this._result = 'draw';
      }
    }
    return true;
  }

  _checkIfWon(who) {
    // check rows
    for (let i = 0; i < 3; i++) {
      if ((this._b[i][0] == who) && (this._b[i][1] == who) && (this._b[i][2] == who)) {
        return true;
      }
    }
    // check columns
    for (let i = 0; i < 3; i++) {
      if ((this._b[0][i] == who) && (this._b[1][i] == who) && (this._b[2][i] == who)) {
        return true;
      }
    }
    // check first diagonal
    if ((this._b[0][0] == who) && (this._b[1][1] == who) && (this._b[2][2] == who)) {
      return true;
    }
    // check second diagonal
    if ((this._b[0][2] == who) && (this._b[1][1] == who) && (this._b[2][0] == who)) {
      return true;
    }
    return false;
  }

  getSquare(x, y) {
    if (typeof (x) != 'number' || typeof (y) != 'number') {
      return false;
    }
    if (x < 0 || x > 2 || y < 0 || y > 2) {
      return false;
    }
    return this._b[x][y];
  }

  getResult() {
    return this._result;
  }

  getBoardCopy() {
    let copy = [
      [0, 0, 0],
      [0, 0, 0],
      [0, 0, 0]
    ];
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < 3; j++) {
        copy[i][j] = this._b[i][j];
      }
    }
    return copy;
  }
  getBoardJSON() {
    return JSON.stringify(this._b);
  }

  printBoard() {
    console.table(this._b);
  }

}


